<div class="flex flex-col flex-auto min-w-0">
    <div class="flex flex-col flex-auto min-w-0 bg-card dark:bg-transparent">
        <div class="relative flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between py-8 px-6 md:px-8 border-b ">
            <div class="text-4xl font-extrabold tracking-tight">Utilisateurs</div>

            <div class="flex shrink-0 items-center mt-6 sm:mt-0 sm:ml-4">
                <button class="ml-4" mat-flat-button [color]="'primary'" (click)="add()">
                    <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                    <span class="ml-2 mr-1">Ajouter</span>
                </button>
            </div>
        </div>

        <div class="flex flex-auto overflow-hidden">
            <div class="flex flex-col flex-auto sm:mb-18 overflow-hidden sm:overflow-y-auto">
                <div class="grid">
                    <div class="table-grid z-10 sticky top-0 grid gap-4 py-4 px-6 md:px-8 shadow text-md font-semibold text-secondary bg-gray-50 dark:bg-black dark:bg-opacity-5">
                        <div>Nom</div>
                        <div class="right-0">Détail</div>
                    </div>
                    <ng-container *ngFor="let user of users; trackBy: trackByFn">
                        <div class="table-grid grid items-center gap-4 py-3 px-6 md:px-8 border-b">
                            <div class="">{{user.prenom}} {{user.nom}}</div>
                            <div class="right-0">
                                <button class="min-w-10 min-h-7 h-7 px-2 leading-6" mat-stroked-button (click)="edit(user.id)">
                                    <mat-icon class="icon-size-5" [svgIcon]="currentUser?.id === user.id ? 'heroicons_solid:chevron-up' : 'heroicons_solid:chevron-down'"></mat-icon>
                                </button>
                            </div>
                        </div>
                        <div class="grid">
                            <ng-container *ngIf="currentUser?.id === user.id">
                                <ng-container *ngTemplateOutlet="rowDetailsTemplate; context: {$implicit: user}"></ng-container>
                            </ng-container>
                        </div>
                    </ng-container>
                </div>

                <ng-template #rowDetailsTemplate let-user>
                    <div class="shadow-lg overflow-hidden">
                        <div class="flex border-b">
                            <form class="flex flex-col w-full" [formGroup]="userForm" (ngSubmit)="onFormSubmit()">

                                <div class="flex flex-col sm:flex-row p-8 pb-0 space-x-4">
                                    <mat-form-field class="w-full">
                                        <mat-label>Prénom</mat-label>
                                        <input type="text" matInput formControlName="prenom">
                                    </mat-form-field>
                                    <mat-form-field class="w-full">
                                        <mat-label>Nom</mat-label>
                                        <input type="text" matInput formControlName="nom">
                                    </mat-form-field>
                                </div>

                                <div class="flex flex-col sm:flex-row p-8 pb-0 pt-0 space-x-4">
                                    <mat-form-field class="w-full">
                                        <mat-label>Adresse courriel</mat-label>
                                        <input type="text" matInput formControlName="email">
                                    </mat-form-field>
                                    <mat-form-field class="w-full">
                                        <mat-label>Mot de passe</mat-label>
                                        <input type="password" matInput formControlName="password">
                                    </mat-form-field>
                                </div>

                                <div class="flex flex-col sm:flex-row p-8 pt-0 space-x-4" *ngIf="isAdmin">
                                    <mat-form-field class="w-full">
                                        <mat-label>Role</mat-label>
                                        <mat-select formControlName="role_id" [compareWith]="compareRolesSelect">
                                            <mat-option *ngFor="let role of roles" [value]="role.id">
                                                {{role.role}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <div class="w-full"></div>
                                </div>


                                <div class="flex items-center justify-between w-full border-t px-8 py-4">
                                    <button type="button" (click)="delete(user.id)" class="-ml-4" mat-button [color]="'warn'" *ngIf="isAdmin">
                                        Supprimer
                                    </button>
                                    <div class="flex items-center">
                                        <div class="flex items-center mr-4">
                                            <ng-container *ngIf="success">
                                                <mat-icon class="text-green-500" [svgIcon]="'heroicons_outline:check'"></mat-icon>
                                                <span class="ml-2">L'utilisateur a été mis à jour</span>
                                            </ng-container>
                                            <ng-container *ngIf="error">
                                                <mat-icon class="text-red-500" [svgIcon]="'heroicons_outline:x'"></mat-icon>
                                                <span class="ml-2">{{messageErreur}}</span>
                                            </ng-container>
                                        </div>
                                        <button type="submit" mat-flat-button [color]="'primary'">
                                            Enregistrer
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
